import moment from 'moment';
import { Auth } from 'aws-amplify';

export const formatDate = (date) => moment(date).format('MM/DD/YY HH:mm');
export const formatFilterDate = (date) => moment(date).format('MM/DD/YY');

export function replaceUUID(url, value) {
  return url.replace('{uuid}', value);
}

export function formatStatus(status) {
  const formatResult = status.toLowerCase();
  return formatResult.charAt(0).toUpperCase() + formatResult.substring(1);
}

export const formatUserActDetails = ({ value }, rowDetails) => {
  if (rowDetails.isSuccessful === 'Success')
    return value.split('\n').map((item) => {
      if (item.split(':')[0] === 'Updated field/s') {
        return [item.split(':')[0], item.split(':')[1].split(',')];
      }
      return [item.split(':')[0], item.split(':').slice(1).join(':')];
    });
  return [[value.split(':')[0], value.split(':').slice(1).join(':')]];
};

export const formatCopyToClipboard = (rowDetails) => {
  if (rowDetails?.isSuccessful === 'Success') {
    return `Action type: ${rowDetails?.type}\nStatus: ${
      rowDetails?.isSuccessful
    }\nUser: ${rowDetails?.createdBy}\nTimestamp: ${rowDetails?.createdOn}\n${
      rowDetails?.vaultRequestId
        ? `Vaulting Request Identifier: ${rowDetails?.vaultRequestId}`
        : `Contact identifier: ${rowDetails?.buyerContactId}`
    }\n${rowDetails?.details}`;
  }
  return `Action type: ${rowDetails?.type}\nStatus: ${
    rowDetails?.isSuccessful
  }\nUser: ${rowDetails?.createdBy}\nTimestamp: ${rowDetails?.createdOn}\n${
    rowDetails?.vaultRequestId
      ? `Vaulting Request Identifier: ${rowDetails?.vaultRequestId}`
      : `Contact identifier: ${rowDetails?.buyerContactId}`
  }\nReason:${rowDetails?.details.split(':').slice(1).join(':')}`;
};

export function getToken(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : '';
}

export const getIdToken = async () =>
  (await Auth.currentSession()).getIdToken().getJwtToken();

export function getErrorData(err) {
  const UNKNOWN_ERROR = {
    code: 'VPS.E.0000.00',
    type: 'Unknown',
    message: 'Unknown error',
  };
  if (err?.response) {
    if (err.response?.data?.error) return err.response.data.error;
    if (err.response?.data) return err.response.data;
  }
  if (err?.message) return { ...UNKNOWN_ERROR, message: err.message };
  if (typeof err === 'string') return { ...UNKNOWN_ERROR, message: err };
  return { ...UNKNOWN_ERROR };
}
